export default function getJWT() {
  const authData = localStorage.getItem('auth');
  const parseToken = JSON.parse(authData);
  return parseToken.token;
}